import { useEffect, useRef, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import { ChainId } from '@uniswap/sdk'

// 网络状态管理 hook
export function useNetworkState() {
  const { chainId, library } = useWeb3React()
  const [isNetworkChanging, setIsNetworkChanging] = useState(false)
  const lastChainIdRef = useRef<ChainId | undefined>()
  const networkChangeTimeoutRef = useRef<NodeJS.Timeout>()

  useEffect(() => {
    // 检测网络变化
    if (lastChainIdRef.current !== undefined && lastChainIdRef.current !== chainId) {
      setIsNetworkChanging(true)

      // 清除之前的超时
      if (networkChangeTimeoutRef.current) {
        clearTimeout(networkChangeTimeoutRef.current)
      }

      // 设置网络稳定时间
      networkChangeTimeoutRef.current = setTimeout(() => {
        setIsNetworkChanging(false)
      }, 5000) // 5秒后认为网络稳定
    }

    lastChainIdRef.current = chainId
  }, [chainId])

  useEffect(() => {
    if (library && library.provider) {
      const provider = library.provider as any

      // 监听网络变化开始
      const handleNetworkChangeStart = () => {
        setIsNetworkChanging(true)
      }

      // 监听网络变化结束
      const handleNetworkChangeEnd = () => {
        setTimeout(() => {
          setIsNetworkChanging(false)
        }, 2000)
      }

      if (provider.on) {
        provider.on('network', handleNetworkChangeStart)
        provider.on('networkChanged', handleNetworkChangeEnd)
      }

      return () => {
        if (provider.removeListener) {
          provider.removeListener('network', handleNetworkChangeStart)
          provider.removeListener('networkChanged', handleNetworkChangeEnd)
        }
      }
    }

    // 如果没有 library 或 provider，返回 undefined
    return undefined
  }, [library])

  return {
    isNetworkChanging,
    currentChainId: chainId
  }
}

export default useNetworkState
